import React from 'react';
import { byPrefixAndName } from '@awesome.me/kit-d44d3cae94/icons';
import clsx from 'clsx';
import FaIcon, { type FaIconProps } from './FaIcon';

export type { IconPrefix, FaIconSize } from './FaIcon';

/** Public props for the Uvilo-kit FaIcon wrapper (`byPrefixAndName` is injected). */
export type FaIconUviloProps = Omit<FaIconProps, 'byPrefixAndName'>;

/**
 * Renders a Font Awesome icon from the Uvilo kit.
 * Prefer this over the base {@link FaIcon} in app and shared UI call sites.
 */
export default function FaIconUvilo({ className, ...props }: FaIconUviloProps): React.ReactNode {
  'use memo';

  return (
    <FaIcon
      {...props}
      className={clsx('fa-icon-uvilo', className)}
      byPrefixAndName={byPrefixAndName as FaIconProps['byPrefixAndName']}
    />
  );
}
